module.exports = __webpack_public_path__ + "media/images/application/choose-price/poulpe-01-c88c1b163114a26d21f7a444a20c99ca.svg";